const track = (event, params = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', event, params);
  }
};

const tracker = {
  // Countdown
  pageViewCountdown: () => track('page_view_countdown'),
  archiveClick: (year) => track('archive_click', { year }),

  // Function Completed
  pageViewCompleted: () => track('page_view_completed'),

  // Main App
  pageViewMain: () => track('page_view_main'),
  search: (searchTerm, sandhaCount, productCount) =>
    track('search', {
      search_term: searchTerm,
      sandha_count: sandhaCount,
      product_count: productCount,
      total_results: sandhaCount + productCount,
    }),
  donorNotFound: (searchTerm) =>
    track('donor_not_found', { search_term: searchTerm }),
  downloadInvitation: () => track('download_invitation'),
  downloadAgenda: () => track('download_agenda'),
  whatsappShareInvitation: () => track('whatsapp_share_invitation'),
  whatsappShareDonor: (donorId) =>
    track('whatsapp_share_donor', { donor_id: donorId }),
  correctionClick: (donorId) =>
    track('correction_click', { donor_id: donorId }),
  correctionSubmit: (donorId, status) =>
    track('correction_submit', { donor_id: donorId, status }),

  // Operator
  pageViewOperatorLogin: () => track('page_view_operator_login'),
  operatorLogin: (status) => track('operator_login', { status }),
  pageViewOperatorDashboard: () => track('page_view_operator_dashboard'),
  operatorSearch: (query, resultsCount) =>
    track('operator_search', { query, results_count: resultsCount }),
  operatorViewReceipts: (donorId) =>
    track('operator_view_receipts', { donor_id: donorId }),
  operatorDownloadPdf: (invoiceNumber) =>
    track('operator_download_pdf', { invoice_number: invoiceNumber }),
  operatorLogout: () => track('operator_logout'),
};

export default tracker;
